module.exports = __webpack_public_path__ + "static/media/SmartShop_3-200w.e76dad24.png";